
function OnchangeColors() {
  $('.product-block-options__item').each(function () {
     var currentBackgroundImage = $(this).css('background-image');
     var VariantImage = $(this).attr('data-bgset');
     if (VariantImage !== '' && currentBackgroundImage === 'none') {
        $(this).css('background-image', 'url(' + VariantImage + ')');
    }
  });
}

function HoverChange() {
  console.log("Run Swatches code and start here..");
   $( ".product-block-options__inner span.product-block-options__item" ).hover(function() {
      //console.log("Hover...")
      var GetImageID = $(this).attr('data-media');
      var FindParent = $(this).parent().parent().parent().parent().parent().parent();
      //console.log(FindParent);
      $(FindParent).find('.product-block__image.product-block__image--active').removeClass('product-block__image--active');
      $(FindParent).find('.product-block__image[data-media-id="'+GetImageID+'"]').addClass('product-block__image--active');
      $(FindParent).find('.product-block__image.product-block__image--active').next().addClass('product-block__image--show-on-hover');
  });
  console.log("Sucessfully Run Swatches code and end here..");
  
  $('.product-block-options__item').each(function () {
     var currentBackgroundImage = $(this).css('background-image');
     var VariantImage = $(this).attr('data-bgset');
     if(VariantImage != ''){
       console.log("image is not Blank")
       if (currentBackgroundImage === 'none') {
           console.log("Background Image is not non");
          $(this).css('background-image', 'url(' + VariantImage + ')');
       }
     }
     
  });

  // $('a.image-page-button').each(function () {
  //  var ButtonHasRemoved = $(this).attr('href');
  //   if(ButtonHasRemoved == '#'){
  //     $(this).attr('href', 'javascript:void(0)');
  //   }else{

  //   }
  // });
  
}


$( document ).ready(function() {
  setTimeout(function() {
    HoverChange(); 
    
  }, 2000);
});


// $( document ).ready(function() {
//   setTimeout(function() {
//     $('.boost-pfs-filter-products').one('DOMSubtreeModified', function(){
//       HoverChange();
//     });
//   }, 2000);
// });

// $( document ).ready(function() {
  
//     $(document).on("click",".image-page-button",function() {
//       console.log("Clicked...")
//       // setTimeout(function() {
//       $('.boost-pfs-filter-products').bind('DOMSubtreeModified', function(){
//         console.log("Update HTML...")
//         //HoverChange();
//       });
//       // }, 2000);
//     })
  
// });

